(function() {
  if (!window.location.pathname.startsWith('/search')) return;

  var params = new URLSearchParams(window.location.search);
  var q = (params.get('q') || '').toLowerCase().trim();
  if (!q) return;

  var keywords = [
    'correa',
    'correas',
    'cargador',
    'carte sim',
    'protector',
    'chat',
    'whatsapp',
    'app',
    'garantia',
    'manual',
    'tablet',
    'bracelete',
    'funda',
    'protector pantalla',
    'activar sim',
    'contacto',
    'tiendas',
    'regalos',
    'reyes magos',
    'regalos',
    'promocion',
    'ofertas',
    'descuentos',
    'rebajas',
    'promocion',
    'cupon',
    'precio especial',
    'sale',
    'accesorios',
    'smartwatch'

  ];

  for (var i = 0; i < keywords.length; i++) {
    if (q.indexOf(keywords[i]) !== -1) {
      window.location.href = 'https://savefamilygps.com/collections/relojes-adolescentes';
      break;
    }
  }
})();
